import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { autoA11yTest } from "./assets/utils/autoAllyTest";

const root = ReactDOM.createRoot(document.getElementById("root"));

autoA11yTest();
root.render(
  <BrowserRouter basename="/public">
    <App />
  </BrowserRouter>
);

reportWebVitals();
